import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Prevent mobile browser crash from background tab suspension / video play interruptions
window.addEventListener('unhandledrejection', (event) => {
  const msg = event?.reason?.message || String(event?.reason || '');
  if (
    msg.includes('The play() request was interrupted') ||
    msg.includes('ResizeObserver') ||
    msg.includes('Loading chunk') ||
    msg.includes('Failed to fetch') ||
    msg.includes('dynamically imported module') ||
    msg.includes('AbortError')
  ) {
    event.preventDefault();
  }
});

// Auto-recover if tab was discarded or frozen while in background on mobile
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    const rootEl = document.getElementById('root');
    if (rootEl && rootEl.children.length === 0) {
      window.location.reload();
    }
  }
});

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    const rootEl = document.getElementById('root');
    if (rootEl && rootEl.children.length === 0) {
      window.location.reload();
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register();



